import { useState, useRef } from 'react';
import { Loader2, Save, RotateCcw, X } from 'lucide-react';

export default function SignatureCapture({ onSave, onCancel, isLoading }) {
  const canvasRef = useRef(null);
  const [isDrawing, setIsDrawing] = useState(false);

  const startDrawing = (e) => {
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const ctx = canvas.getContext('2d');
    ctx.beginPath();
    ctx.moveTo(e.clientX - rect.left, e.clientY - rect.top);
    setIsDrawing(true);
  };

  const draw = (e) => {
    if (!isDrawing) return;
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const ctx = canvas.getContext('2d');
    ctx.lineTo(e.clientX - rect.left, e.clientY - rect.top);
    ctx.stroke();
  };

  const stopDrawing = () => {
    setIsDrawing(false);
  };

  const clearCanvas = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
  };

  const handleSave = () => {
    const canvas = canvasRef.current;
    const signatureData = canvas.toDataURL('image/png');
    onSave(signatureData);
  };

  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-secondary-900 mb-2">
          Draw Your Signature
        </label>
        <div className="border-2 border-secondary-300 rounded-lg overflow-hidden bg-white">
          <canvas
            ref={canvasRef}
            width={400}
            height={200}
            className="w-full cursor-crosshair bg-white"
            onMouseDown={startDrawing}
            onMouseMove={draw}
            onMouseUp={stopDrawing}
            onMouseLeave={stopDrawing}
          />
        </div>
      </div>

      {/* Legal Notice */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
        <p className="text-xs text-blue-800">
          <span className="font-semibold">Legal Notice:</span> By signing, you certify that you have reviewed this document and approve it for processing. This digital signature is legally binding.
        </p>
      </div>

      {/* Actions */}
      <div className="flex gap-3">
        <button
          onClick={clearCanvas}
          disabled={isLoading}
          className="btn-secondary flex-1"
          title="Clear signature"
        >
          <RotateCcw size={16} />
          Clear
        </button>
        <button
          onClick={onCancel}
          disabled={isLoading}
          className="btn-secondary flex-1"
        >
          <X size={16} />
          Cancel
        </button>
        <button
          onClick={handleSave}
          disabled={isLoading}
          className="btn-primary flex-1"
        >
          {isLoading ? (
            <>
              <Loader2 size={16} className="animate-spin" />
              Saving...
            </>
          ) : (
            <>
              <Save size={16} />
              Approve & Sign
            </>
          )}
        </button>
      </div>
    </div>
  );
}
